import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';

export default function useParametrosEntidade(idEntidade) {
  const [params, setParams] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!idEntidade) {
      setParams({});
      return;
    }
    const token = localStorage.getItem('token');
    setLoading(true);
    axios.get(`${API_BASE_URL.PARAMETRO}/entidade/${idEntidade}/map`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => setParams(res.data || {}))
      .catch(() => setParams({}))
      .finally(() => setLoading(false));
  }, [idEntidade]);

  return { params, loading };
}
